export default "__VITE_ASSET__CC2W52Cw__"